export default __webpack_public_path__ + "static/media/logo.3e4790a7.svg";